module.exports = __webpack_public_path__ + "static/media/arrow-right-home.9dbfe02b.svg";